// extracted by mini-css-extract-plugin
export var alignCenter = "_5p-d";
export var bannerShown = "_5p-6";
export var buttonContent = "_5p-0";
export var cardList = "_5p-1";
export var centerContent = "_5p-2";
export var chevron = "_5p-3";
export var closePanelButton = "_5p-k";
export var conversationContextContainer = "_5p-l";
export var conversationDetailContainer = "_5p-4";
export var detailWrapper = "_5p-7";
export var dropdownButton = "_5p-e";
export var dropdownTitle = "_5p-9";
export var fullHeight = "_5p-5";
export var hidden = "_5p-a";
export var icon = "_5p-b";
export var mergeSuggestionWrapper = "_5p-m";
export var panel = "_5p-i";
export var portalButtonsWrapper = "_5p-c";
export var right = "_5p-j";
export var tableSummaryContainer = "_5p-8";
export var tableSummaryHeader = "_5p-g";
export var threeDotsButton = "_5p-f";
export var wide = "_5p-h";